export default "__VITE_ASSET__ad4a8fee__"